import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import QueryTable from "../../../../ui/QueryTable";
import useQuery from "../../../../ui/QueryTable/useQuery";

const items = [
  {
    label: "Сервис",
    link: "#"
  },
  {
    label: "Вопросы с сайта",
    link: "#"
  }
];

const QuestionRequestList = () => {
  const query = useQuery(4);

  useEffect(() => {
    query.load();
  }, []);

  return (
    <div>
      <Breadcrumbs items={items}/>
      <QueryTable {...query} />
    </div>
  );
};

export default QuestionRequestList;
